import React from "react";
import axios from "../../../../../axios";
import { Box, Button } from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";
import { toast } from "react-toastify";

const AssessPopupBox = ({ props, setIsDeactivated }) => {
  const handleDeactivate = async () => {
    try {
      const body = { status: "draft" };
      const res = await axios.put(
        `/api/v1/homework/updateStatus/${props.id}`,
        body,
      );
      if (res.status === 200) {
        setIsDeactivated((prev) => !prev);
        toast.success("Homework deactivated successfully");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        bgcolor: "background.paper",
        boxShadow: 3,
        minWidth: 180,
      }}
    >
      <Button
        variant="outlined"
        color="warning"
        startIcon={<BlockIcon />}
        fullWidth
        sx={{ textTransform: "none", whiteSpace: "nowrap" }}
        onClick={handleDeactivate}
      >
        Deactivate
      </Button>
    </Box>
  );
};

export default AssessPopupBox;
